import React from 'react';
import axios from 'axios';
import {
    toggleShowAddOrgUnitType,
    fetchOrgUnitTypes,
    selectOrgUnitType,
    addOrgUnitType
} from './../../../reduxFiles/actionTypes';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import typeIcon from './../speech-bubble.svg';
import { Item, Button, Label, Icon, Segment, Dropdown } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class OrgUnitType extends React.Component {

    constructor(props) {
        super(props);

        this.showAddType = this.showAddType.bind(this);
        this.addType = this.addType.bind(this);

        if (this.props.isAddingType) {
            this.props.dispatch(toggleShowAddOrgUnitType());
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.orgUnitId !== nextProps.orgUnitId && this.props.isAddingType) {
            this.props.dispatch(toggleShowAddOrgUnitType());
        }
    }

    showAddType() {
        this.props.dispatch(fetchOrgUnitTypes());
        this.props.dispatch(toggleShowAddOrgUnitType());
    }

    addType() {
        const orgUnitType = {
            id: this.props.orgUnitTypeIdToAdd
        }
        this.props.dispatch(addOrgUnitType(this.props.orgUnitId, orgUnitType));
    }

    render() {
        const {types, isAddingType, orgUnitTypes, addingTypeError, orgUnitTypeIdToAdd} = this.props;

        if (orgUnitTypes.error) {
            toast(<FormattedMessage id='orgUnitDetailed.errors.gettingOrgUnitTypes'/>);
        }
        if (addingTypeError) {
            toast(<FormattedMessage id='orgUnitDetailed.errors.addingOrgUnitTypes'/>);
        }

        return (
            <Item>
                <Item.Image src={typeIcon} size='tiny'/>
                <Item.Content style={{paddingRight: '21px'}}>
                    <Item.Header><AddOrgUnitTypeButton showAddType={this.showAddType}/></Item.Header>
                    <Item.Description>
                        {isAddingType && orgUnitTypes.items.length &&
                            <Segment raised>
                                <Dropdown clearable
                                    onChange={(e, {value}) => this.props.dispatch(selectOrgUnitType(value))}
                                    fluid
                                    selection
                                    style={{marginBottom: '5px'}}
                                    value={orgUnitTypeIdToAdd}
                                    options={orgUnitTypes.items.filter(orgUnitType => (types.find(types => orgUnitType.name === types)) === undefined).map(orgUnitType =>
                                        ({ key: orgUnitType.id, value: orgUnitType.id, text: orgUnitType.name })
                                    )}/>
                                    <Icon circular name='check' onClick={this.addType}/>
                                    <Icon circular name='cancel' onClick={() => {this.props.dispatch(toggleShowAddOrgUnitType());}}/>
                            </Segment>
                        }
                        <div className="ui bulleted list">
                            {types.map((type, index) =>
                                <div className="item" key={index}>{type}</div>
                            )}
                        </div>
                    </Item.Description>
                </Item.Content>
            </Item>
        );
    }
}

const AddOrgUnitTypeButton = (props) => (
    <Button as='div' labelPosition='left' onClick={(event, data) => {props.showAddType()}}>
        <Label as='a' basic pointing='right'><FormattedMessage id='orgUnitDetailed.types'/></Label>
        <Button icon>
            <Icon name='plus' />
        </Button>
    </Button>
)

function mapStateToProps(state) {
    return {
        isAddingType: state.ui.orgUnitsView.typeView.isAddingType,
        orgUnitTypeIdToAdd: state.ui.orgUnitsView.typeView.orgUnitTypeIdToAdd,
        orgUnitTypes: state.data.orgUnitTypes,
        isSendingType: state.ui.orgUnitsView.typeView.isSendingType,
        addingTypeError: state.ui.orgUnitsView.typeView.addingTypeError
    }
}

export default connect(mapStateToProps)(OrgUnitType);



// WEBPACK FOOTER //
// ./src/views/OrganizationalUnit/components/OrgUnitType.js